import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, Button, FieldTextInput } from '../../components';
import * as validators from '../../util/validators';
import Reaptcha from 'reaptcha';

import css from './ContactForm.module.css';

const { REACT_APP_RECAPTCHA_SITE_KEY } = process.env;

const ContactFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        invalid,
        contactUsError,
        contactUsSuccess,
        form
      } = fieldRenderProps;

      const [isVerified, setVerified] = useState(false);

      const onVerify = recaptchaResponse => {
        setVerified(true);
      };

      // name
      const nameLabel = intl.formatMessage({
        id: 'ContactForm.nameLabel',
      });
      const namePlaceholder = intl.formatMessage({
        id: 'ContactForm.namePlaceholder',
      });
      // email
      const emailLabel = intl.formatMessage({
        id: 'ContactForm.emailLabel',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'ContactForm.emailPlaceholder',
      });
      const emailRequiredMessage = intl.formatMessage({
        id: 'ContactForm.emailRequired',
      });
      const emailRequired = validators.required(emailRequiredMessage);
      const emailInvalidMessage = intl.formatMessage({
        id: 'ContactForm.emailInvalid',
      });
      const emailValid = validators.emailFormatValid(emailInvalidMessage);

      // message
      const messageLabel = intl.formatMessage({
        id: 'ContactForm.messageLabel',
      });
      const messagePlaceholder = intl.formatMessage({
        id: 'ContactForm.messagePlaceholder',
      });
      const messageRequiredMessage = intl.formatMessage({
        id: 'ContactForm.messageRequired',
      });
      const messageRequired = validators.required(messageRequiredMessage);

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress || !isVerified;


      if(contactUsSuccess) {
        form.restart();
      }

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.inputsWrapper}>
            <FieldTextInput
              className={css.contactUsInput}
              type="text"
              id={formId ? `${formId}.name` : 'name'}
              name="name"
              autoComplete="name"
              label={nameLabel}
              placeholder={namePlaceholder}
              validate={messageRequired}
            />
            <FieldTextInput
              className={css.contactUsInput}
              type="email"
              id={formId ? `${formId}.email` : 'email'}
              name="email"
              autoComplete="email"
              label={emailLabel}
              placeholder={emailPlaceholder}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
          </div>
          <FieldTextInput
            className={css.message}
            type={'textarea'}
            id={formId ? `${formId}.message` : 'message'}
            name="message"
            autoComplete="current-message"
            label={messageLabel}
            placeholder={messagePlaceholder}
            validate={messageRequired}
          />
          <div className={css.recaptchaHolder}>
            <Reaptcha sitekey={REACT_APP_RECAPTCHA_SITE_KEY} onVerify={onVerify} />
          </div>
          <div className={css.bottomWrapper}>
            <Button type="submit" inProgress={submitInProgress} disabled={submitDisabled} className={css.contactUsButton}>
              <FormattedMessage id="ContactForm.btn" />
            </Button>
          </div>
          {contactUsSuccess &&  (
            <p className={css.successMsg}>
              <FormattedMessage id="ContactForm.successMsg" values={{ lineBreak: <br/>}} />
            </p>
          )}
          {!!contactUsError &&  (
            <p className={css.error}>
              <FormattedMessage id="EnquiryForm.sendEnquiryError" />
            </p>
          )}

        </Form>
      );
    }}
  />
);

ContactFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  form: null,
  inProgress: false,
};

const { string, bool } = PropTypes;

ContactFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  form: string,
  inProgress: bool,

};

const ContactForm = compose(injectIntl)(ContactFormComponent);
ContactForm.displayName = 'ContactForm';

export default ContactForm;
